// see https://docs.sentry.io/platforms/javascript/?platform=react

import * as Sentry from '@sentry/browser';
import { Component, ReactNode } from 'react';

interface ErrorBoundaryProps {
    children: ReactNode;
    errorMessage?: ReactNode;
}

interface ErrorBoundaryState {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error: any;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    public override state: ErrorBoundaryState = {
        error: null,
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public override componentDidCatch(error: any, errorInfo: any) {
        this.setState({ error });
        Sentry.withScope(scope => {
            Object.keys(errorInfo).forEach(key => {
                scope.setExtra(key, errorInfo[key]);
            });
            Sentry.captureException(error);
        });
    }

    public override render() {
        if (this.state.error) {
            // render fallback UI

            if (this.props.errorMessage) {
                return this.props.errorMessage;
            }

            return <span>There was an error, please reload your browser</span>;
        } else {
            // when there's not an error, render children untouched
            return this.props.children;
        }
    }
}
